import React from "react";
import styled from "styled-components";

const StyledTitleSection = styled.div`
  color: #39393d;
  font-size: 16px;
  font-family: Roboto, sans-serif;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 1rem 0;
  color: #fff;
  background-color: #0097e6;
  .title-section-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    .title-section-text {
      font-size: 16px;
      font-family: RobotoBold, sans-serif;
      line-height: calc(1.42857rem * (14 / 16));
      color: #FFFFFF;
    }
  }
  @media (min-width: 768px) {
    .title-section-container {
      width: 750px;
    }
  }
  @media (min-width: 992px) {
    .title-section-container {
      width: 970px;
    }
  }

  @media (min-width: 1024px) {
    .title-section-container {
      width: 990px;
    }
  }
  @media (min-width: 1200px) {
    .title-section-container {
      width: 1170px;
    }
  }
  @media (min-width: 1280px) {
    .title-section-container {
      padding-left: 40px;
      padding-right: 40px;
      width: 1170px;
    }
  }
  @media (min-width: 1600px) {
    .title-section-container {
      padding-left: 115px;
      padding-right: 115px;
      width: 1440px;
    }
  }
`;

function TitleSection({ title }) {
  return (
    <StyledTitleSection>
      <div className="title-section-container">
        <div className="title-section-text">
          {title && (
            <span>{title}</span>
          )}
        </div>
      </div>
    </StyledTitleSection>
  );
}

export default TitleSection;
